import React from 'react';
import NamedLink from '../NamedLink/NamedLink';
import { listingBookingLinkProps } from '../../util/bookingIntent';
import { LISTENER_PRIMARY_CTA } from '../../util/listenerAvailability';
import { skillOffersFromListing } from '../../util/sweetSkills';
import { createSlug } from '../../util/urlHelpers';
import { useShowFreeCtas } from '../FirstSessionFree/FirstSessionFree';
import { pathsFromListing, isFeaturedPath, pathLabels } from '../../util/topicPaths';
const topicChips = (listing, max) => {
  const deep = pathsFromListing(listing).filter(isFeaturedPath).sort((a, b) => b.split('/').length - a.split('/').length);
  const out = [];
  deep.forEach(p => { const l = pathLabels(p).slice(-1)[0]; if (l && !out.includes(l) && out.length < max) out.push(l); });
  return out;
};
import css from './ThumbCtas.module.css';

// Sam Oct 27 2026 (TEST): CTAs under every listener thumbnail, never over faces.
// Available Now → Talk free (new/free-eligible) or Let’s talk; Busy/offline → Book for Later.
// Teachers also get Learn free / Let’s learn. Both roles show both.
// Sam Oct 28: Talk free for people who still have a free session (guests + eligible).
const stop = e => e.stopPropagation();

// Sam Oct 28 (TEST): meta line under thumb — Available now · Free 15 · No ID (free-eligible only) + 1–2 topics.
const ThumbCtas = ({ listing, availability, skillId = null, disabled = false, showTopics = true }) => {
  const id = listing?.id?.uuid;
  const showFree = useShowFreeCtas();
  if (!id) return null;
  const slug = createSlug(listing?.attributes?.title || '') || 'listener';
  const talkNow = availability?.primaryCta === LISTENER_PRIMARY_CTA.TALK_NOW;
  const listenLink = talkNow
    ? listingBookingLinkProps({ id, slug, mode: 'now' })
    : { name: 'ListingBookingPage', params: { id, slug }, to: { search: '?mode=later' } };
  const skills = skillOffersFromListing(listing);
  const skill = (skillId && skills.find(o => o.id === skillId)) || null;
  // Sam Nov 2 2026: generic Learn must not lock the first skill; only a skill-filtered card passes offer=.
  const learnLink = skill
    ? { name: 'ListingBookingPage', params: { id, slug }, to: { search: `?mode=later&offer=${encodeURIComponent(skill.id)}` } }
    : skills.length
    ? { name: 'ListingBookingPage', params: { id, slug }, to: { search: '?mode=later&learn=1' } }
    : null;
  const dis = disabled ? { 'aria-disabled': 'true', style: { opacity: 0.5, pointerEvents: 'none' } } : {};
  const talkLabel = talkNow ? (showFree ? 'Start free now' : 'Start now') : 'Book a Sweet Spot';
  const learnLabel = showFree ? 'Learn free' : 'Let’s learn';
  let topics = [];
  try { topics = showTopics ? (topicChips(listing, 2) || []) : []; } catch (e) { topics = []; }
  const meta = [];
  if (talkNow) meta.push(<span key="a" className={css.avail} data-thumb-meta="available">Online</span>);
  if (showFree) {
    meta.push(<span key="f" className={css.free} data-thumb-meta="free15">Free 15 min</span>);
    // Sam Nov 3 1:03 PM: no "No ID" / "No card" badges on thumbnails.
  }
  return (
    <>
    {meta.length || topics.length ? (
      <div className={css.meta} data-thumb-meta-row="true">
        {meta}
        {topics.map(t => <span key={`t-${t}`} className={css.topic} title={t}>{t}</span>)}
      </div>
    ) : null}
    <div className={css.row} data-thumb-ctas="true" onClick={stop}>
      <NamedLink
        {...listenLink}
        className={talkNow ? css.talk : css.later}
        data-thumb-cta={talkNow ? (showFree ? 'start-free-now' : 'start-now') : 'later'}
        {...dis}
      >
        {talkLabel}
      </NamedLink>
      {learnLink ? (
        <NamedLink {...learnLink} className={css.learn} data-thumb-cta={showFree ? 'learn-free' : 'learn'} {...dis}>
          {learnLabel}
        </NamedLink>
      ) : null}
    </div>
    </>
  );
};

export default ThumbCtas;
